'use client'
import { Icon, Tag } from '@core/ui-elements'
import { CardColors, cardColorSchemaList } from '@utils/styles'
import dayjs from 'dayjs'
import { FC, useEffect, useState } from 'react'
import { MdCircle } from 'react-icons/md'

export interface ICountdownTimer {
  countTime: number
  targetTime: string
  colorIcon?: CardColors
  colorSchema?: CardColors
  bgColor?: string
  callAtTime?: (minutes: number) => void | null
  label?: string
  size?: 'xs' | 'sm' | 'md' | 'lg'
}

export const CountdownTimer: FC<ICountdownTimer> = ({
  countTime,
  targetTime,
  colorIcon,
  colorSchema = CardColors.gray,
  bgColor,
  callAtTime = null,
  label,
  size = 'sm',
}) => {
  const [differenceTime, setDifferenceTime] = useState<number>(0)

  const calculateDifferenceTime = () => {
    const currentTime = dayjs(targetTime)
    const countDownDate = currentTime.add(countTime + 1, 'seconds')

    const elapsedTime = countDownDate.diff()

    if (elapsedTime <= 0) {
      setDifferenceTime(0)
    } else {
      setDifferenceTime(elapsedTime)
    }

    if (callAtTime) {
      callAtTime(elapsedTime)
    }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => calculateDifferenceTime(), [])

  useEffect(() => {
    if (differenceTime > 0) {
      setTimeout(() => {
        calculateDifferenceTime()
      }, 1000)
    }
  })

  return (
    <Tag
      backgroundColor={bgColor || cardColorSchemaList[colorSchema].secondary}
      size={size}
    >
      <Icon
        as={MdCircle}
        boxSize="0.5rem"
        color={cardColorSchemaList[colorIcon || colorSchema].primary}
      />{' '}
      {dayjs(differenceTime).format('mm:ss')}
      {label && ' ' + label}
    </Tag>
  )
}
